import { createFileRoute, Outlet } from '@tanstack/react-router';

// Legacy brand-hub layout shell. The hub UI itself (rail + panes)
// was retired in favour of the brand workbench drawer — see
// the brand workbench design doc (CommitMind). Every leaf under this layout
// (`/brand/$slug/identity`, `/voice`, `/customer`, …) now does a
// beforeLoad → redirect to `/brand/$slug/home?brand=full&brandTab=…`,
// so this layout never actually renders. We keep the file as a
// minimal Outlet to preserve the file-router tree shape — without
// it, the leaves would orphan and the redirects would never be
// reached.
//
// Safe to delete once we've shipped a few releases and no incoming
// links from older bookmarks land on these URLs.
export const Route = createFileRoute('/brand/$slug/_brand')({
  component: () => <Outlet />,
});
